import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Shop from "../pages/shop/page";
import ProductDetail from "../pages/product-detail/page";
import Cart from "../pages/cart/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import Gifting from "../pages/gifting/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/shop",
    element: <Shop />,
  },
  {
    path: "/product/:slug",
    element: <ProductDetail />,
  },
  {
    path: "/cart",
    element: <Cart />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/gifting",
    element: <Gifting />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
